/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import React from "react";
import axios from "../api/axiosInstance";
import {
  buildDraftGroupAddRoomsPayload,
  canAddDraftGroupRooms,
  getDraftGroupApiErrorMessage,
} from "../reservations/groupDraftUiContracts";

export default function GroupInfoCard({
  formData,
  permissions,
  roomToAdd,
  setRoomToAdd,
  groupReservations,
  setGroupReservations,
  setFormData,
  setHasAnyDates,
  setCopyFromOptions,
  setCopyToOptions,
  businessUnitId
}) {
  const canAddRooms = canAddDraftGroupRooms(permissions);

  return (

<div className="card bg-dark text-light p-3 mb-3" style={{ width: "100%", maxWidth: "100%", zoom: "85%" }}>
    <h5 className="text-warning mb-2">Group Information</h5>
    <div className="d-flex justify-content-between align-items-center mb-1" style={{ gap: "2rem" }}>
        <p className="mb-0">
          <strong>Locator:</strong> {formData.group_locator || "Pending"}
        </p>
        {canAddRooms && (
        <div className="d-flex align-items-center gap-2">
          <label className="form-label mb-0">Rooms to Add:</label>
          <input
            type="number"
            min="1"
            value={roomToAdd}
            onChange={(e) => setRoomToAdd(parseInt(e.target.value, 10))}
            className="form-control form-control-sm"
            style={{ width: "80px" }}
          />


          <button
            className="btn btn-sm btn-success fw-bold px-3"
            onClick={async () => {
              const increment = parseInt(roomToAdd, 10);
              const currentTotal = groupReservations.length;
            
              if (isNaN(increment) || increment <= 0) return;
            
              const newTotal = currentTotal + increment;
            
              try {
                // (removed) Draft cleanup prevention is no longer needed

                const response = await axios.post(
                  `${process.env.REACT_APP_API_URL}/api/reservation-draft-groups/${formData.reservation_group_id}/add-rooms`,
                  buildDraftGroupAddRoomsPayload({
                    reservationGroupId: formData.reservation_group_id,
                    newTotal,
                    businessUnitId,
                  })
                );

                console.log("[DraftGroup][AddRooms][OK]", response.data);

                // 🔁 Refetch drafts del grupo (DB = source of truth)
                const groupRes = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/reservation-drafts/draft-groups/${formData.reservation_group_id}/reservations`
                );

                setGroupReservations(groupRes.data);

                console.log(
                  "[DraftGroup][AddRooms][REFETCH]",
                  groupRes.data.map(r => ({ id: r.id, group_index: r.group_index }))
                );

                console.log("📦 [setGroupReservations] (add-rooms) Group updated after adding rooms:", groupRes.data);

                // 🔁 Refrescar Copy Info tras añadir habitaciones
                setTimeout(async () => {
                  try {
                    const copyRes = await axios.get(
                      `${process.env.REACT_APP_API_URL}/api/reservation-groups/${formData.reservation_group_id}/copy-info-options`
                    );
                    console.log("🔁 Copy Info actualizado tras añadir habitaciones:", copyRes.data);
                    setHasAnyDates(copyRes.data.has_any_dates);
                    setCopyFromOptions(copyRes.data.copy_from_options);
                    setCopyToOptions(copyRes.data.copy_to_options);
                  } catch (err) {
                    console.warn("⚠️ No se pudo actualizar Copy Info tras añadir habitaciones:", err);
                  }
                }, 500);

                setFormData((prev) => ({
                  ...prev,
                  group_total_rooms: newTotal,
                }));
            
                setRoomToAdd(1);
              } catch (error) {
                console.error("❌ Error al añadir habitaciones:", error);
                alert(
                  getDraftGroupApiErrorMessage(
                    error,
                    "Error adding rooms to group."
                  )
                );
              }
            }}
            
          >
            Add Room
          </button>
        </div>
      )}
      </div>

      </div>
  );
}
